<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item :label="$t('views.orderPayment.form.orderId')" prop="orderId">-->
<!--        <a-input-->
<!--          v-model="form.orderId"-->
<!--          :disabled="orderIdLocked"-->
<!--          :placeholder="$t('views.orderPayment.form.orderIdPlaceholder')"-->
<!--        />-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('views.orderPayment.form.type')" prop="type">
        <a-select
          v-model="form.type"
          disabled
          :placeholder="$t('views.orderPayment.form.typePlaceholder')"
          style="width: 100%"
        >
          <a-select-option
            v-for="opt in paymentTypeOptions"
            :key="String(opt.value)"
            :value="opt.value"
          >
            {{ opt.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.orderPayment.form.money')" prop="money">
        <a-input v-model="form.money" disabled :placeholder="$t('views.orderPayment.form.moneyPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.orderPayment.form.url')" prop="url">
<!--        <a-input-->
<!--          v-model="form.url"-->
<!--          :placeholder="$t('views.orderPayment.form.urlPlaceholder')"-->
<!--          type="textarea"-->
<!--          allow-clear-->
<!--        />-->
        <img style="width: 48px;height: 48px;margin-right: 5px;margin-bottom: 5px" v-image-preview :src="item" v-for="(item,index) in (form.url || '').split(',').map(s => s.trim()).filter(Boolean)">
      </a-form-model-item>
      <a-form-model-item :label="$t('views.orderPayment.form.auditStatus')" prop="auditStatus">
        <a-select
          v-model="form.auditStatus"
          style="width: 100%"
          :placeholder="$t('views.orderPayment.form.auditStatusPlaceholder')"
        >
          <a-select-option
            v-for="opt in auditStatusOptions"
            :key="String(opt.value)"
            :value="opt.value"
          >
            {{ opt.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <template v-if="showFinalPaymentDeliveryFields">
        <a-form-model-item :label="$t('views.goodsOrder.orderBox.deliveryNumber')" prop="deliveryNumber">
          <a-input
            v-model="form.deliveryNumber"
            :maxLength="255"
            :placeholder="$t('views.goodsOrder.modal.markShippedDeliveryNumberPlaceholder')"
            allow-clear
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('views.goodsOrder.orderBox.deliveryTime')" prop="deliveryTime">
          <a-date-picker
            v-model="form.deliveryTime"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="$t('views.goodsOrder.orderBox.deliveryTimePlaceholder')"
            style="width: 100%"
          />
        </a-form-model-item>
      </template>
      <template v-if="showAuditReasonFields">
        <a-form-model-item :label="$t('views.orderPayment.form.auditReason')" prop="auditReason">
          <a-input
            v-model="form.auditReason"
            :placeholder="$t('views.orderPayment.form.auditReasonPlaceholder')"
            type="textarea"
            allow-clear
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('views.orderPayment.form.auditReasonEn')" prop="auditReasonEn">
          <a-input
            v-model="form.auditReasonEn"
            :placeholder="$t('views.orderPayment.form.auditReasonEnPlaceholder')"
            type="textarea"
            allow-clear
          />
        </a-form-model-item>
      </template>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.orderPayment.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.orderPayment.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import { getOrderPayment, addOrderPayment, updateOrderPayment } from '@/api/user/orderPayment'

export default {
  name: 'CreateForm',
  props: {
    /** 从订单列表等入口预填并锁定订单 ID */
    presetOrderId: {
      type: [String, Number],
      default: null
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        orderId: null,

        type: null,

        money: null,

        url: null,

        auditStatus: 1,

        auditReason: null,

        auditReasonEn: null,

        deliveryNumber: '',

        deliveryTime: null,

        sort: null,

        status: 1,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    orderIdLocked () {
      return this.presetOrderId !== null && this.presetOrderId !== undefined && this.presetOrderId !== ''
    },
    paymentTypeOptions () {
      return [
        { value: 0, label: this.$t('views.orderPayment.paymentType.full') },
        { value: 1, label: this.$t('views.orderPayment.paymentType.first') },
        { value: 2, label: this.$t('views.orderPayment.paymentType.final') }
      ]
    },
    auditStatusOptions () {
      return [
        { value: 0, label: this.$t('views.orderPayment.auditStatus.pending') },
        { value: 1, label: this.$t('views.orderPayment.auditStatus.approved') },
        { value: 2, label: this.$t('views.orderPayment.auditStatus.rejected') }
      ]
    },
    /** 仅审核驳回(2)时展示中英文审核原因 */
    showAuditReasonFields () {
      const v = this.form && this.form.auditStatus
      return Number(v) === 2
    },
    /** 尾款付款(type=2) 审核时展示主订单发货单号、发货时间 */
    showFinalPaymentDeliveryFields () {
      return this.formType === 2 && Number(this.form.type) === 2
    }
  },
  watch: {
    'form.auditStatus' (val) {
      if (Number(val) !== 2) {
        this.form.auditReason = null
        this.form.auditReasonEn = null
      }
    }
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    /** 详情若返回蛇形 audit_reason_en，合并到 camelCase 并去掉多余字段 */
    normalizeDetailFromApi () {
      if (this.form.audit_reason_en != null && (this.form.auditReasonEn == null || this.form.auditReasonEn === '')) {
        this.form.auditReasonEn = this.form.audit_reason_en
      }
      if (Object.prototype.hasOwnProperty.call(this.form, 'audit_reason_en')) {
        delete this.form.audit_reason_en
      }
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        orderId: null,
        type: null,
        money: null,
        url: null,
        auditStatus: 1,
        auditReason: null,
        auditReasonEn: null,
        deliveryNumber: '',
        deliveryTime: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
    },
    parseDeliveryTimeFromApi (val) {
      if (val == null || val === '') {
        return null
      }
      const m = moment(val)
      return m.isValid() ? m : null
    },
    formatDeliveryTimeForSubmit (val) {
      if (val == null) {
        return undefined
      }
      if (typeof val.format === 'function') {
        return val.format('YYYY-MM-DD HH:mm:ss')
      }
      const m = moment(val)
      return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : undefined
    },
    applyDeliveryFieldsFromDetail (payload) {
      const dn = payload.deliveryNumber != null
        ? payload.deliveryNumber
        : (payload.delivery_number != null ? payload.delivery_number : '')
      this.form.deliveryNumber = dn != null ? String(dn) : ''
      const dt = payload.deliveryTime != null ? payload.deliveryTime : payload.delivery_time
      this.form.deliveryTime = this.parseDeliveryTimeFromApi(dt)
    },
    buildSubmitPayload () {
      const payload = { ...this.form }
      if (this.showFinalPaymentDeliveryFields) {
        payload.deliveryNumber = this.form.deliveryNumber != null ? String(this.form.deliveryNumber).trim() : ''
        payload.deliveryTime = this.formatDeliveryTimeForSubmit(this.form.deliveryTime)
      } else {
        delete payload.deliveryNumber
        delete payload.deliveryTime
      }
      return payload
    },
    validateFinalPaymentDeliveryBeforeSubmit () {
      if (!this.showFinalPaymentDeliveryFields || Number(this.form.auditStatus) !== 1) {
        return true
      }
      const dn = this.form.deliveryNumber != null ? String(this.form.deliveryNumber).trim() : ''
      if (!dn) {
        this.$message.warning(this.$t('views.goodsOrder.msg.markShippedDeliveryNumberRequired'))
        return false
      }
      if (!this.formatDeliveryTimeForSubmit(this.form.deliveryTime)) {
        this.$message.warning(this.$t('views.goodsOrder.msg.markShippedDeliveryTimeRequired'))
        return false
      }
      return true
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('views.orderPayment.form.titleAdd')
      if (this.orderIdLocked) {
        this.form.orderId = this.presetOrderId
      }
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrderPayment({ id }).then(response => {
        const payload = response && (response.data !== undefined && response.data !== null ? response.data : response)
        this.form = { ...this.form, ...payload }
        this.normalizeDetailFromApi()
        if (this.form.type !== null && this.form.type !== undefined && this.form.type !== '') {
          const n = Number(this.form.type)
          this.form.type = Number.isNaN(n) ? this.form.type : n
        }
        if (this.form.auditStatus === null || this.form.auditStatus === undefined || this.form.auditStatus === '') {
          this.form.auditStatus = 1
        } else {
          const a = Number(this.form.auditStatus)
          this.form.auditStatus = Number.isNaN(a) ? 1 : a
        }
        /** 审核入口（待审核打开）：默认选中审核通过 */
        if (Number(this.form.auditStatus) === 0) {
          this.form.auditStatus = 1
        }
        this.applyDeliveryFieldsFromDetail(payload)
        this.open = true
        this.formTitle = this.$t('views.orderPayment.form.titleEdit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.validateFinalPaymentDeliveryBeforeSubmit()) {
            return false
          }
          const payload = this.buildSubmitPayload()
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateOrderPayment(payload).then(response => {

              if(response.success) {
                this.$message.success(this.$t('views.orderPayment.msg.updateOk'), 3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.orderPayment.msg.updateFail');
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addOrderPayment(payload).then(response => {
              if(response.success) {
                this.$message.success(this.$t('views.orderPayment.msg.addOk'), 3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.orderPayment.msg.addFail');
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
